import { render, staticRenderFns } from "./SetPasswordByEmail.vue?vue&type=template&id=0c81396f&"
import script from "./SetPasswordByEmail.vue?vue&type=script&lang=js&"
export * from "./SetPasswordByEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports